var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-text-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.1987 11.2002H20.7987M11.1987 17.6002H16.7987M28.7987 16.0002C28.7987 17.8402 28.4105 19.5896 27.7114 21.1708L28.8012 28.799L22.2639 27.1647C20.412 28.2062 18.2747 28.8002 15.9987 28.8002C8.92949 28.8002 3.19873 23.0694 3.19873 16.0002C3.19873 8.93095 8.92949 3.2002 15.9987 3.2002C23.068 3.2002 28.7987 8.93095 28.7987 16.0002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIc);
export default __webpack_public_path__ + "static/media/SMS_IC.3c08057c36facf7291035e9850f86909.svg";
export { ForwardRef as ReactComponent };